import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'confirmation-modal',
  template: `
      <div class="modal-body text-center">
        <p>{{ title }}</p>
        <button type="button" class="btn btn-primary" (click)="onConfirm()">{{'common.yes' | translate}}</button>
        <button type="button" class="btn btn-danger" (click)="onCancel()">{{'common.no' | translate}}</button>
      </div>
    `
})
export class ConfirmationModalComponent implements OnInit, OnDestroy {
  public active: boolean = false;
  public body: string;
  public title: string;
  public onClose: Subject<boolean>;

  public constructor(private _bsModalRef: BsModalRef) {}

  ngOnDestroy() {
    this.onClose.complete();
  }
  public ngOnInit(): void {
    this.onClose = new Subject();
  }

  public showConfirmationModal(title: string): void {
    this.title = title;
    this.active = true;
  }

  public onConfirm(): void {
    this.active = false;
    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.active = false;
    this.onClose.next(false);
    this._bsModalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/modals/confirmation/confirmation-modal.component.ts